import React from "react";
import { Phone } from "lucide-react";
import { Button } from "../ui/button";
import { Reveal, Starburst } from "../common";
import { useLead } from "../LeadDialog";
import { CONTACT } from "../../data/site";

const QuoteCTA = () => {
  const { openLead } = useLead();
  return (
    <section className="py-8 bg-white" data-testid="quote-cta-section">
      <div className="max-w-[88rem] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] bg-jet-ink text-white px-6 py-16 md:px-16 md:py-24 text-center">
            <Starburst className="absolute -left-10 -top-10 h-48 w-48 text-jet-teal/10" />
            <Starburst className="absolute -right-8 -bottom-8 h-40 w-40 text-jet-amber/10" />
            <div className="relative">
              <div className="inline-flex items-center gap-2 text-xs md:text-sm font-bold uppercase tracking-[0.22em] text-jet-amber mb-6">
                <Starburst className="h-3 w-3 text-jet-amber" /> The Future of Cleaning
              </div>
              <h2 className="font-display font-semibold text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-4xl mx-auto text-balance">
                Let's make cleaning easy.
              </h2>
              <p className="mt-5 text-white/60 text-lg max-w-xl mx-auto">
                Fast, honest pricing. Dependable scheduling. A team that shows up.
                Reach out today.
              </p>
              <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
                <Button
                  onClick={() => openLead("quote")}
                  className="rounded-full bg-jet-teal hover:bg-jet-teal-deep text-white font-bold h-14 px-8 text-base teal-glow"
                  data-testid="quote-cta-quote"
                >
                  Request Quote
                </Button>
                <a
                  href={CONTACT.phoneHref}
                  className="inline-flex items-center gap-2 rounded-full border-2 border-white/30 hover:border-white text-white font-bold h-14 px-8 text-base transition-colors"
                  data-testid="quote-cta-call"
                >
                  <Phone className="h-5 w-5" /> Call Now
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default QuoteCTA;
